import React, { useMemo } from 'react';

import { Checkbox } from '@mui/material';
import { Col, Form, Spinner, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import { Button } from '../../../components';
import './styles.scoped.css';

const FormContent = ({
  confirmPushNotification,
  isLoading,
  handleCancel,
  handleRadio,
  handleCheckbox,
  isLoadingBranches,
  isLoadingLOBs,
  isLoadingRecipientStatus,
  errors,
  headerTitle,
  customStyles,
  recipientStatuses,
  form,
  setForm,
  location,
  setShowDeleteModal,
  lobs,
  branches,
  isReadOnly,
}) => {
  const user = useSelector(state => state.admin?.user);

  const branchesOptions = useMemo(
    () =>
      branches?.map(({ BranchName, Branch }) => ({
        label: BranchName,
        value: Branch,
        key: Branch,
      })),
    [branches],
  );

  const lobsOptions = useMemo(
    () =>
      lobs?.map(({ LineOfBusinessCode, LineOfBusinessDesc }) => ({
        label: LineOfBusinessCode,
        value: LineOfBusinessDesc,
        key: LineOfBusinessCode,
      })),
    [lobs],
  );

  const driverStatusesOptions = useMemo(
    () =>
      recipientStatuses?.map(({ REF_CODE, REF_DESCRIPTION }) => ({
        label: REF_DESCRIPTION,
        value: REF_CODE,
        key: REF_CODE,
      })),
    [recipientStatuses],
  );

  return (
    <div className="wrap">
      <Row>
        <Col>
          <div className="window-header">
            <span>{headerTitle}</span>
          </div>
          <div className="window-container pt-3">
            <Col style={{ fontWeight: 'bold' }} className="mb-4 pb-4 ml-0">
              <p style={{ marginBottom: '0px' }}>
                Select the button for the type of survey group and any necessary filters.
              </p>
              <p style={{ marginBottom: '0px' }}>
                Select the recipient statuses, approve the message to send and click SAVE.
              </p>
            </Col>
            <Col className="mb-4 ml-2">
              <Form.Check
                type="radio"
                label="Send to ALL Drivers with selected status with the CMA"
                name="type"
                id="National"
                checked={form?.type === 'National'}
                onChange={() => handleRadio('National')}
                disabled={isReadOnly}
              />
            </Col>
            <Col className="mb-4 pt-4 ml-2">
              <Form.Check
                type="radio"
                label="Send to ALL Drivers with selected status for these Lines of Business"
                name="type"
                id="LOB"
                checked={form?.type === 'LOB'}
                onChange={() => handleRadio('LOB')}
                disabled={isReadOnly}
              />
              <Col className="mx-4 pl-4 mt-4">
                <Row className="m-0 p-0 align-items-center">
                  <Form.Label className="required mr-3">LOB</Form.Label>
                  <Select
                    isDisabled={form?.type !== 'LOB' || isLoadingLOBs || isReadOnly}
                    styles={customStyles('100%')}
                    options={lobsOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    onChange={selectedOptions => {
                      const selectedLOBs = selectedOptions.map(option => option.value);
                      setForm({
                        ...form,
                        lob: selectedLOBs.join(', '),
                      });
                    }}
                    value={
                      form?.type === 'LOB' && !isLoadingLOBs
                        ? form?.lob?.split(', ').map(lob => lobsOptions?.find(option => option.value === lob) || '')
                        : ''
                    }
                  />
                  <div className="dropdown-spinner-container">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      aria-hidden="true"
                      className="dropdown-spinner"
                      hidden={!isLoadingLOBs}
                    />
                  </div>
                </Row>
                {form?.type === 'LOB' && !isLoadingLOBs && errors?.lob && <span className="error">{errors?.lob}</span>}
              </Col>
            </Col>
            <Col className="mb-4 pt-4 ml-2">
              <Form.Check
                type="radio"
                label="Send to ALL Drivers with selected status for these Branches"
                name="type"
                id="Branch"
                checked={form?.type === 'Branch'}
                onChange={() => handleRadio('Branch')}
                disabled={isReadOnly}
              />
              <Row className="mr-0 ml-0">
                <Col className="mx-4 pl-4 mt-4">
                  <Row className="m-0 p-0 align-items-center">
                    <Form.Label className="required mr-3">Branch</Form.Label>
                    <Select
                      isDisabled={form?.type !== 'Branch' || isLoadingBranches || isReadOnly}
                      styles={customStyles('100%')}
                      options={branchesOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      onChange={selectedOptions => {
                        const selectedBranches = selectedOptions.map(option => option.value);
                        setForm({
                          ...form,
                          branch: selectedBranches.join(', '),
                        });
                      }}
                      value={
                        form?.type === 'Branch' && !isLoadingBranches
                          ? form?.branch
                            ?.split(', ')
                            .map(branch => branchesOptions?.find(option => String(option.value) === branch) || '')
                          : ''
                      }
                    />
                    <div className="dropdown-spinner-container">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        aria-hidden="true"
                        className="dropdown-spinner"
                        hidden={!isLoadingBranches}
                      />
                    </div>
                  </Row>
                  {form?.type === 'Branch' && !isLoadingBranches && errors?.branch && (
                    <span className="error">{errors?.branch}</span>
                  )}
                </Col>
                <Col className="mx-4 pl-4 mt-4">
                  <Row className="m-0 p-0 align-items-center">
                    <Form.Label className="required mr-3">LOB</Form.Label>
                    <Select
                      isDisabled={form?.type !== 'Branch' || isLoadingLOBs || isReadOnly}
                      styles={customStyles('100%')}
                      options={lobsOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      onChange={selectedOptions => {
                        const selectedLOBs = selectedOptions.map(option => option.value);
                        setForm({
                          ...form,
                          lob: selectedLOBs.join(', '),
                        });
                      }}
                      value={
                        form?.type === 'Branch' && !isLoadingLOBs
                          ? form?.lob?.split(', ').map(lob => lobsOptions?.find(option => option.value === lob) || '')
                          : ''
                      }
                    />
                    <div className="dropdown-spinner-container">
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        aria-hidden="true"
                        className="dropdown-spinner"
                        hidden={!isLoadingLOBs}
                      />
                    </div>
                  </Row>
                  {form?.type === 'Branch' && !isLoadingLOBs && errors?.lob && (
                    <span className="error">{errors?.lob}</span>
                  )}
                </Col>
              </Row>
            </Col>
            <Col className="mb-4 pt-4 ml-2 pl-3">
              <Row className="m-0 p-0 align-items-center">
                <Form.Label className="required mr-3">Recipient Status</Form.Label>
                <Select
                  isDisabled={isReadOnly}
                  styles={customStyles('100%')}
                  options={driverStatusesOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  onChange={selectedOptions => {
                    const selectedStatuses = selectedOptions.map(option => option.value);
                    setForm({
                      ...form,
                      recipientStatus: selectedStatuses.join(', '),
                    });
                  }}
                  value={form?.recipientStatus
                    ?.split(', ')
                    .map(status => driverStatusesOptions?.find(option => option.value === status) || '')}
                />
                <div className="dropdown-spinner-container">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    aria-hidden="true"
                    className="dropdown-spinner"
                    hidden={!isLoadingRecipientStatus}
                  />
                </div>
              </Row>
              {errors?.recipientStatus && <span className="error">{errors?.recipientStatus}</span>}
            </Col>
            <Row className="pt-4 pl-4 align-items-center" style={{ color: isReadOnly ? '#666' : '#000' }}>
              <Checkbox
                checked={isReadOnly ? true : form?.approvedBy === user?.name}
                style={{
                  color: isReadOnly ? '#ff000088' : 'red',
                  height: 0,
                  marginLeft: '15px',
                  marginRight: '15px',
                  width: 0,
                }}
                onChange={handleCheckbox}
                disabled={isReadOnly}
              />
              <span>
                <strong>Approved to send </strong>(Checking this box and clicking SAVE will send the Survey
                Notification.)
              </span>
            </Row>
          </div>
          <Row className="justify-content-center mt-4 mb-5">
            {location.pathname.includes('edit') && (
              <Button
                variant="outline"
                style={{
                  height: '40px',
                  width: '100px',
                  marginRight: '8px',
                }}
                onPress={() => {
                  setShowDeleteModal(true);
                }}
                text="Delete"
              />
            )}
            {isLoading && (
              <div style={{ margin: '4px' }}>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="spinner"
                  hidden={!isLoading}
                />
              </div>
            )}
            {!isReadOnly && (
              <Button
                variant="primary"
                onPress={() => {
                  confirmPushNotification();
                }}
                text="Save"
              />
            )}
            <Button
              variant="outline"
              className="ml-2"
              onPress={() => {
                handleCancel();
              }}
              text="Cancel"
            />
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default FormContent;
